import { createContext } from 'react';

export type SupportedLanguage = 'en' | 'it' | 'fr' | 'de'

export const localeContext = createContext<SupportedLanguage>('en')
